import { DataGeoJsonFeature } from '@daisi/models/data-geojson-feature';

export const EMPTY_FEATURE_COLLECTION = {
  type: 'FeatureCollection',
  features: [],
};

export interface FeatureCollection<
  FeatureProperties,
  Feature extends DataGeoJsonFeature<FeatureProperties> = DataGeoJsonFeature<FeatureProperties>,
> {
  type: 'FeatureCollection';
  features: Feature[];
}
